import { transferringListStateName } from '../../../../components/tickets/ticketOverview/ticketOverview.state';
import { receivingListStateName } from '../../../../components/tickets/ticketOverview/ticketOverview.state';
import { receivingCreateRequestStateName } from '../../../../components/tickets/create/receiving/createRequest/createRequest.state';
import { uploadWarrantStateName } from '../../../../components/tickets/create/transferring/uploadWarrant/uploadWarrant.state';
import {
  TicketType,
  ProductType,
} from '../../../../components/ticket/ticket.constants';
import { UserPermissions } from '../../../user/user.roles';
import { FeatureFlagNames } from '../../../featureFlags/featureFlags';

export const KWHTab = {
  id: 'KWH',
  text: 'navbar.link.product.KWH.title',
  requiresAuth: true,
  dropdown: {
    recievingTitle: {
      group: 'receiving',
      text: 'navbar.link.receiving.title',
      isTitle: true,
    },
    recievingTickets: {
      group: 'receiving',
      ref: receivingListStateName,
      params: { product: ProductType.KWH },
      text: 'navbar.link.receiving.tickets.title',
      icon: 'fa fa-fw m-right-xs-5 fa-tasks',
      permissions: [UserPermissions[TicketType.Receiving].Read],
    },
    recievingRequest: {
      group: 'receiving',
      ref: receivingCreateRequestStateName,
      params: { nachlass: false },
      text: 'navbar.link.receiving.createRequest.title',
      icon: 'fa fa-fw m-right-xs-5 fa-pencil-square-o',
      permissions: [UserPermissions[TicketType.Receiving].Create],
    },
    nachlass: {
      group: 'receiving',
      ref: receivingCreateRequestStateName,
      params: { nachlass: true },
      text: 'navbar.link.receiving.nachlass.title',
      icon: 'fa fa-fw m-right-xs-5 fa-cloud',
      permissions: [UserPermissions[TicketType.Receiving].Create],
      featureFlag: FeatureFlagNames.FF_NACHLASS,
    },
    transferringDivider: {
      group: 'transferring',
      text: 'navbar.link.receiving.title',
      isDivider: true,
    },
    transferringTitle: {
      group: 'transferring',
      text: 'navbar.link.transferring.title',
      isTitle: true,
    },
    transferringTickets: {
      group: 'transferring',
      ref: transferringListStateName,
      text: 'navbar.link.transferring.tickets.title',
      icon: 'fa fa-fw m-right-xs-5 fa-tasks',
      permissions: [
        UserPermissions[TicketType.Transferring].Read,
        UserPermissions[TicketType.Transferring].Complete,
      ],
    },
    transferringRequest: {
      group: 'transferring',
      ref: uploadWarrantStateName,
      text: 'navbar.link.transferring.request.title',
      icon: 'fa fa-fw m-right-xs-5 fa-upload',
      permissions: [UserPermissions[TicketType.Transferring].Create],
    },
  },
};

export const KWSTab = {
  id: 'KWS',
  ref: receivingListStateName,
  params: { product: ProductType.KWS },
  text: 'navbar.link.product.KWS.title',
  requiresAuth: true,
  permissions: [UserPermissions[TicketType.Receiving].Read],
};

export const DWSTab = {
  id: 'DWS',
  ref: receivingListStateName,
  params: { product: ProductType.DWS },
  text: 'navbar.link.product.DWS.title',
  requiresAuth: true,
  permissions: [UserPermissions[TicketType.Receiving].Read],
};
